import {z} from 'zod';

export const MarketSituationEnumSchema = z.enum([
  'MARKET_SITUATION_MAJOR_SHORTAGE',
  'MARKET_SITUATION_SHORTAGE',
  'MARKET_SITUATION_STABLE',
  'MARKET_SITUATION_SURPLUS',
]);
export type MarketSituationEnum = z.infer<typeof MarketSituationEnumSchema>;
